import {faFilePdf, faSpinner} from '@fortawesome/fontawesome-pro-regular';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React from 'react';
import {usePdfExport, generatePdfData} from '../../../../hooks/usePdfExport';
import {useTracking} from '../../../../services/analytics/TrackingContext';

export const PdfLink = ({rowData, column, styleSheet}) => {
  const {trackResultClick} = useTracking();
  let exportPdfData = generatePdfData(rowData);
  exportPdfData.benefitType = `${exportPdfData.benefitType} Benefit`;

  const handlePdfExportWithTracking = (e) => {
    e.preventDefault();
    if (rowData) {
      trackResultClick('detailed_brochure', rowData);
    }
    handlePdfExport(e);
  };

  // Using the usePdfExport hook to generate the PDF
  const {isGenerating, handlePdfExport} = usePdfExport({
    templateId: column.meta.templateId,
    templateName: column.meta.templateName,
    data: {data: [exportPdfData]},
    namePrefix: 'pdf-link',
    id: rowData.id
  });

  return (
    isGenerating ? (
      <FontAwesomeIcon icon={faSpinner} spin size="lg" />
    ) : (
      <a
        id={rowData.id}
        onClick={handlePdfExportWithTracking}
        data-testid={`pdf-link-${rowData.id}`}
        style={{cursor: 'pointer'}}
        title={column.meta.title}
      >
        <FontAwesomeIcon icon={faFilePdf} size={'2x'} />
      </a>
    )
  );
};
